/* gregwein.js — "Talk to a Wine Expert" storefront widget (Big Hammer Wines brand).
 *
 * TWO mount modes, same chat engine:
 *   • INLINE  — if a container (#gregwein-chat or [data-gregwein-chat]) exists on the
 *     page, the chat renders INSIDE it, always open, full-width: the centerpiece of
 *     /pages/ask-greg. No floating button.
 *   • MODAL — otherwise, the chat opens as a CENTERED overlay (dimmed backdrop). An
 *     in-page button (window.GregWein.open()) or the optional floating bubble triggers
 *     it. Set window.GREGWEIN_NO_BUTTON = true to suppress the floating bubble (when the
 *     page has its own CTA / already has another chat bubble).
 *
 * Brand (per BHW Brand Guidelines): plum #403863, violet #83549B, gold #E8DCA6,
 * cream #F8F8D8; EB Garamond (serif) text, Proxima Nova→Nunito Sans (sans) for UI.
 * Both fonts load on the theme; the Shadow DOM uses them, falls back gracefully.
 *
 * Recommendations ADD TO CART inline (Shopify /cart/add.js); product links open
 * SAME-TAB; the conversation persists across navigation. Page chips can fire a
 * question via the global  window.GregWein.ask("...").
 *
 * Config: window.GREGWEIN_ENDPOINT = "https://.../chat"  (or data-endpoint on the tag).
 */
(function () {
  "use strict";
  var ENDPOINT = window.GREGWEIN_ENDPOINT ||
    (document.currentScript && document.currentScript.getAttribute("data-endpoint")) ||
    "/apps/gregwein/chat";
  var CTA = "Talk to a Wine Expert";
  var LAUNCHER = window.GREGWEIN_LAUNCHER || "pill";        // pill | avatar
  var SIDE = window.GREGWEIN_SIDE === "left" ? "left" : "right";
  var AVATAR = window.GREGWEIN_AVATAR || "";                // founder photo URL (avatar launcher)
  var PAGE = window.GREGWEIN_PAGE || {};                    // {template, handle, title} — page-aware
  var OFFSET_B = parseInt(window.GREGWEIN_OFFSET_BOTTOM, 10);  // raise the launcher to clear other corner widgets
  if (isNaN(OFFSET_B)) OFFSET_B = 20;

  // Wake the serverless backend the instant the chat opens, so the first real message
  // skips the cold start. The GET hits the cheap health route (no model/Redis) — by the
  // time the user reads the greeting and types, the instance is booted. Keep-warm re-pings
  // while the chat is open so a long pause doesn't fall back onto a reaped (cold) instance.
  var warmTimer;
  function warm() { try { fetch(ENDPOINT, { method: "GET", keepalive: true, cache: "no-store" }).catch(function () {}); } catch (e) {} }

  var sid = localStorage.getItem("gregwein_sid");
  if (!sid) { sid = "s_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
              localStorage.setItem("gregwein_sid", sid); }
  var history = [];
  try { history = JSON.parse(localStorage.getItem("gregwein_hist") || "[]"); } catch (e) {}
  // Fresh conversation after 72h idle (per browser/user): if the saved thread hasn't been
  // touched in 72 hours, start clean with a NEW session id so a stale chat never lingers and
  // the page-aware greeting fires fresh on return.
  try {
    var _ts = parseInt(localStorage.getItem("gregwein_hist_ts") || "0", 10);
    if (_ts && (Date.now() - _ts) > 72 * 3600 * 1000) {
      history = [];
      localStorage.removeItem("gregwein_hist");
      localStorage.removeItem("gregwein_hist_ts");
      sid = "s_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem("gregwein_sid", sid);
    }
  } catch (e) {}

  var root, panel, log, input, backdrop, built = false, busy = false, greeted = false, inlineMode = false;

  function el(tag, attrs, html) {
    var e = document.createElement(tag);
    if (attrs) for (var k in attrs) e.setAttribute(k, attrs[k]);
    if (html != null) e.innerHTML = html;
    return e;
  }
  function esc(s) { var d = document.createElement("div"); d.textContent = s == null ? "" : s; return d.innerHTML; }

  function md(s) {                           // safe markdown-lite
    s = esc(s);
    s = s.replace(/([a-z])\.([A-Z])/g, "$1. $2");   // restore a missing space after a sentence period ("you.Here" -> "you. Here")
    s = s.replace(/\[([^\]]+)\]\((https?:[^)\s]+)\)/g, '<a href="$2" target="_blank" rel="noopener">$1</a>');
    s = s.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
    s = s.replace(/^#{1,6}\s*/gm, "").replace(/^---+$/gm, "");
    return s.replace(/\n{2,}/g, "<br><br>").replace(/\n/g, "<br>");
  }

  var SERIF = "Garamond,'EB Garamond','Garamond Premier Pro',Georgia,'Times New Roman',serif";
  var SANS = "'proxima-nova','Nunito Sans','Helvetica Neue',Arial,sans-serif";
  var PLUM = "#403863", VIOLET = "#83549B", GOLD = "#E8DCA6", CREAM = "#F8F8D8";

  var CSS =
    ":host{all:initial}" +
    ".btn{position:fixed;right:20px;bottom:20px;z-index:2147483000;background:" + PLUM + ";color:#fff;" +
    "border:none;border-radius:999px;padding:14px 22px;font:600 15px/1 " + SANS + ";cursor:pointer;" +
    "box-shadow:0 6px 24px rgba(64,56,99,.35);letter-spacing:.2px}" +
    ".btn.left{left:20px;right:auto}" +
    /* compact launcher: face + permanent "Ask Greg" label, no hover reveal — it must read
       as the assistant at a glance (Greg 2026-07-02) */
    ".btn.avatar{display:inline-flex;align-items:center;gap:0;padding:4px}" +
    ".gw-ava{width:44px;height:44px;border-radius:50%;flex:0 0 44px;min-width:44px;box-sizing:border-box;" +
    "background:" + CREAM + " center/cover no-repeat;border:2px solid " + GOLD + "}" +
    ".gw-ini{display:flex;align-items:center;justify-content:center;background:" + VIOLET + ";" +
    "color:" + CREAM + ";font:600 16px/1 " + SANS + "}" +
    ".gw-lab{color:#fff;font:600 13px/1 " + SANS + ";letter-spacing:.2px;white-space:nowrap;padding:0 14px 0 10px}" +
    "@media(max-width:480px){.gw-lab{font-size:12px;padding:0 12px 0 8px}}" +
    ".panel{position:fixed;right:20px;bottom:20px;z-index:2147483001;width:384px;max-width:94vw;" +
    "height:580px;max-height:84vh;background:#fff;border-radius:14px;box-shadow:0 14px 50px rgba(64,56,99,.32);" +
    "display:flex;flex-direction:column;overflow:hidden;font:16px/1.55 " + SERIF + ";color:#1a1320}" +
    /* inline mode: sit in the page, fill the container, taller, gold-edged */
    ".panel.inline{position:static;right:auto;bottom:auto;width:100%;max-width:none;height:600px;" +
    "max-height:74vh;border:1px solid " + GOLD + ";border-radius:16px;box-shadow:0 10px 34px rgba(64,56,99,.14)}" +
    /* modal mode: dimmed backdrop + centered panel (CTA-triggered) */
    ".backdrop{position:fixed;top:0;right:0;bottom:0;left:0;background:rgba(26,19,32,.5);z-index:2147483000;display:none}" +
    ".panel.modal{left:50%;top:50%;right:auto;bottom:auto;transform:translate(-50%,-50%);width:420px}" +
    /* small screens: edge-anchored bottom sheet — a translated centered box drifts off-screen
       when mobile Safari zooms/resizes the visual viewport */
    "@media(max-width:640px){.panel.modal{left:8px;right:8px;top:auto;bottom:8px;transform:none;" +
    "width:auto;max-width:none;height:78vh;max-height:78vh}}" +
    ".hd{background:" + PLUM + ";color:#fff;padding:13px 18px;font:600 18px/1.2 " + SERIF + ";" +
    "display:flex;justify-content:space-between;align-items:center}" +
    ".hd .sub{font:400 12px/1.3 " + SANS + ";opacity:.85;letter-spacing:.2px}" +
    ".hd button{background:none;border:none;color:#fff;font-size:22px;cursor:pointer;line-height:1}" +
    ".panel.inline .hd button{display:none}" +
    ".log{flex:1;overflow-y:auto;padding:18px;background:" + CREAM + "}" +
    ".m{margin:0 0 12px;padding:10px 13px;border-radius:13px;max-width:88%;font-size:15px}" +
    ".u{background:" + PLUM + ";color:#fff;margin-left:auto;border-bottom-right-radius:4px}" +
    ".a{background:#fff;border:1px solid " + GOLD + ";border-bottom-left-radius:4px}" +
    ".a a{color:" + VIOLET + ";font-weight:600}" +
    ".cards{display:flex;flex-direction:column;gap:9px;margin-top:9px}" +
    ".card{border:1px solid " + GOLD + ";border-radius:11px;padding:9px;background:#fff}" +
    ".cl{display:flex;gap:11px;text-decoration:none;color:#1a1320;align-items:center}" +
    ".cl img,.cl .ph{width:40px;height:54px;object-fit:contain;flex:none}" +
    ".cl b{display:block;font:600 14px/1.25 " + SERIF + ";color:" + VIOLET + "}" +
    ".cl .pr{color:" + PLUM + ";font-weight:700;font-size:14px}" +
    ".add{margin-top:8px;width:100%;background:" + PLUM + ";color:#fff;border:none;border-radius:8px;" +
    "padding:8px 10px;font:600 13px/1 " + SANS + ";cursor:pointer;letter-spacing:.3px}" +
    ".add.done{background:#2f7d4f;cursor:default}" +
    ".ft{display:flex;gap:8px;padding:12px;border-top:1px solid #efe7d6;background:#fff}" +
    /* input stays at 16px: anything smaller makes iOS Safari auto-zoom on focus, which
       shoves the fixed panel half off-screen */
    ".ft input{flex:1;border:1.5px solid #d9cdbf;border-radius:999px;padding:11px 16px;font:16px " + SERIF + ";outline-color:" + PLUM + "}" +
    ".ft button{background:" + PLUM + ";color:#fff;border:none;border-radius:999px;padding:0 20px;cursor:pointer;font:600 14px " + SANS + "}" +
    ".ft .gw-mic{background:" + PLUM + ";border:none;color:#fff;width:40px;min-width:40px;height:40px;padding:0;display:inline-flex;align-items:center;justify-content:center;border-radius:50%}" +
    ".ft .gw-mic.live{background:#c0392b;border-color:#c0392b;color:#fff;animation:gwpulse 1.6s infinite}" +
    ".ft .gw-mic[disabled]{opacity:.5;cursor:wait}" +
    "@keyframes gwpulse{0%,100%{box-shadow:0 0 0 0 rgba(192,57,43,.35)}50%{box-shadow:0 0 0 8px rgba(192,57,43,0)}}" +
    ".typing{color:#9a8fa6;font-style:italic}" +
    // perceived-latency "working" state: a rotating in-voice line + shimmering skeleton
    // bars fill the pre-first-token gap so a selling turn never shows dead air.
    ".gw-think{display:flex;flex-direction:column;gap:9px}" +
    ".gw-status{color:#6b5f78;font-style:italic;font-size:14px;min-height:20px;transition:opacity .25s}" +
    ".gw-sk{height:11px;border-radius:6px;background:linear-gradient(90deg," + CREAM + " 25%,#fff 37%,"
      + CREAM + " 63%);background-size:400% 100%;animation:gwsh 1.4s ease infinite}" +
    ".gw-sk.w1{width:92%}.gw-sk.w2{width:78%}.gw-sk.w3{width:62%}" +
    "@keyframes gwsh{0%{background-position:100% 0}100%{background-position:0 0}}";

  function save() {
    try { localStorage.setItem("gregwein_hist", JSON.stringify(history.slice(-12)));
          localStorage.setItem("gregwein_hist_ts", String(Date.now())); } catch (e) {}
  }

  function add(role, htmlContent) {
    var m = el("div", { class: "m " + (role === "user" ? "u" : "a") });
    m.innerHTML = htmlContent;
    log.appendChild(m);
    log.scrollTop = log.scrollHeight;
    return m;
  }
  function launcherLabel() {              // page-aware bubble label
    var t = (PAGE && PAGE.template) || "";
    if (t === "product") return "Ask about this wine";
    if (t === "collection") return "Help me choose";
    return "Ask Greg";
  }
  function greet() {
    if (greeted) return;
    greeted = true;
    var t = (PAGE && PAGE.template) || "", msg;
    if (t === "product" && PAGE.title) {  // the bot opens already knowing the wine you're on
      msg = "Curious about the " + esc(PAGE.title) + "? I can tell you how it tastes, what it "
          + "pairs with, and whether it's worth it — or tell me what else you're in the mood for.";
    } else if (t === "collection") {
      msg = "Browsing the collection? Tell me a grape you love, a dinner you're pairing, or a "
          + "budget, and I'll point you to the right bottle.";
    } else {
      msg = "Hi — I'm here to help you find the right bottle. Tell me a grape you love, a "
          + "dinner you're pairing, a budget, or just ask “what's good today?”";
    }
    add("a", msg);
  }
  function cards(products) {
    if (!products || !products.length) return "";
    var h = '<div class="cards">';
    products.slice(0, 4).forEach(function (p) {
      h += '<div class="card"><a class="cl" target="_blank" rel="noopener" href="' + esc(p.url) + '">'
        + (p.image ? '<img src="' + esc(p.image) + '" alt="">' : '<span class="ph"></span>')
        + '<span><b>' + esc(p.title) + '</b>'
        + (p.price != null ? '<span class="pr">$' + esc(p.price) + "</span>" : "") + "</span></a>"
        + (p.variant_id ? '<button class="add" data-v="' + esc(p.variant_id) + '"'
            + (p.handle ? ' data-h="' + esc(p.handle) + '"' : "") + ">Add to cart</button>" : "")
        + "</div>";
    });
    return h + "</div>";
  }

  // ---- VOICE (Phase C, flag: window.GREGWEIN_VOICE) --------------------------------
  // Mic in OUR panel -> /voice-session (Origin-gated signed URL; the agent itself
  // requires auth) -> @elevenlabs/client runs the call (mic/turn-taking/barge-in/TTS in
  // Greg's cloned voice); every spoken word is our gated engine's text (the shim).
  var MIC_SVG = '<svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true"><path d="M12 15.5a4.2 4.2 0 0 0 4.2-4.2V6.7a4.2 4.2 0 1 0-8.4 0v4.6A4.2 4.2 0 0 0 12 15.5z"/><path d="M18.9 11.3a6.9 6.9 0 0 1-13.8 0H3a9 9 0 0 0 7.9 8.6V23h2.2v-3.1A9 9 0 0 0 21 11.3h-2.1z"/></svg>';
  var STOP_SVG = '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><rect x="6" y="6" width="12" height="12" rx="2"/></svg>';
  var micBtn = null, voiceConv = null, voiceBusy = false;
  var VOICE_URL = ENDPOINT.replace(/\/chat\/?$/, "") + "/voice-session";
  var VOICE_CARDS_URL = ENDPOINT.replace(/\/chat\/?$/, "") + "/voice-cards";
  var voiceUid = null, voicePoll = null, voiceSeen = {};

  function pollVoiceCards() {
    if (!voiceUid) return;                     // (still sweeps once after hang-up)
    fetch(VOICE_CARDS_URL + "?sid=v-" + encodeURIComponent(voiceUid))
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) {
        var fresh = (j.products || []).filter(function (p) { return p.handle && !voiceSeen[p.handle]; });
        if (!fresh.length) return;
        fresh.forEach(function (p) { voiceSeen[p.handle] = 1; });
        add("bot", cards(fresh));               // same clickable cards + Add to Cart as text chat
      })
      .catch(function () {});
  }

  function voiceNote(txt) { add("bot", "<em>" + esc(txt) + "</em>"); }

  function voiceUI(state) {                     // idle | connecting | live
    if (!micBtn) return;
    micBtn.disabled = state === "connecting";
    micBtn.classList.toggle("live", state === "live");
    micBtn.innerHTML = state === "live" ? STOP_SVG : MIC_SVG;
    micBtn.title = state === "live" ? "End the call" : "Talk to Greg";
  }

  function withTimeout(promise, ms) {          // an ignored mic-permission prompt must
    return Promise.race([promise, new Promise(function (_, rej) {   // never deadlock the button
      setTimeout(function () { rej(new Error("voice timeout")); }, ms);
    })]);
  }

  async function toggleVoice() {
    if (voiceBusy) return;
    if (voiceConv) { endVoice(); return; }
    voiceBusy = true; voiceUI("connecting");
    try {
      try {                                        // pre-flight the mic FIRST: clean error
        var pf = await withTimeout(navigator.mediaDevices.getUserMedia({ audio: true }), 25000);
        pf.getTracks().forEach(function (tr) { tr.stop(); });
      } catch (pe) {
        var blocked = pe && (pe.name === "NotAllowedError" || pe.name === "SecurityError");
        voiceNote(blocked
          ? "Your browser is blocking the microphone for this site. Click the lock icon in the address bar \u2192 Site settings \u2192 Microphone \u2192 Allow, then tap the mic again."
          : "Couldn't reach a microphone \u2014 check it's plugged in and allowed, or just type.");
        try { console.warn("[gregwein voice] mic preflight:", pe && pe.name, pe && pe.message); } catch (ce) {}
        voiceConv = null; voiceUI("idle"); voiceBusy = false; return;
      }
      var r = await fetch(VOICE_URL, { headers: { "Accept": "application/json" } });
      if (!r.ok) throw new Error("session " + r.status);
      var j = await r.json();
      var lib = await import("https://cdn.jsdelivr.net/npm/@elevenlabs/client@1.14.0/+esm");
      voiceUid = "w" + Math.random().toString(16).slice(2, 12) + Date.now().toString(16).slice(-4);
      voiceSeen = {};
      var sess = { customLlmExtraBody: { uid: voiceUid },
        onMessage: function (m) {
          try { console.warn("[gregwein voice] msg", JSON.stringify(m).slice(0, 200)); } catch (e0) {}
          var txt = (m && (m.message || m.text)) || "";
          if (!txt) return;
          if (m.source === "user") add("user", esc(txt));
          else add("bot", md(txt));
        },
        onStatusChange: function (s) {
          try { console.warn("[gregwein voice] status", JSON.stringify(s)); } catch (e1) {}
          var st = (s && s.status) || s;
          if (st === "disconnected") { voiceConv = null; voiceUI("idle"); }
        },
        onDisconnect: function (d) {
          try { console.warn("[gregwein voice] disconnect", JSON.stringify(d)); } catch (e2) {}
        },
        onError: function (er) {
          try { console.warn("[gregwein voice] error", er && (er.message || er)); } catch (e3) {}
          voiceNote("Voice hit a snag \u2014 type your question instead."); endVoice();
        }
      };
      if (j.conversation_token) {      // the platform's preferred WebRTC path
        sess.conversationToken = j.conversation_token;
        sess.connectionType = "webrtc";
      } else {                          // WS fallback
        sess.signedUrl = j.signed_url;
        sess.connectionType = "websocket";
      }
      voiceConv = await withTimeout(lib.Conversation.startSession(sess), 25000);
      voiceUI("live");
      voiceNote("\uD83D\uDD34 Live \u2014 you're talking with the AI version of Greg. Tap \u23F9 to hang up.");
      voicePoll = setInterval(pollVoiceCards, 4000);   // his picks appear as cards mid-call
    } catch (e) {
      try { console.warn("[gregwein voice]", e && (e.name || ""), e && (e.message || e)); } catch (ce) {}
      voiceNote(String(e).indexOf("timeout") > -1
        ? "No microphone access \u2014 allow the mic and tap \uD83C\uDF99 again, or just type."
        : "Voice isn't available right now \u2014 type your question instead.");
      voiceConv = null; voiceUI("idle");
    } finally {
      voiceBusy = false;
    }
  }

  function endVoice() {
    var c = voiceConv; voiceConv = null;
    if (voicePoll) { clearInterval(voicePoll); voicePoll = null; }
    setTimeout(pollVoiceCards, 10);                    // one last sweep after hang-up
    voiceUI("idle");
    if (c && c.endSession) { try { c.endSession(); } catch (e) {} }
  }

  async function addToCart(variantId, handle, btn) {
    if (btn.disabled) return;
    var orig = btn.textContent;
    btn.textContent = "Adding…";
    try {
      var r = await fetch("/cart/add.js", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      });
      if (!r.ok) throw new Error("add failed");
      btn.textContent = "Added ✓"; btn.disabled = true; btn.classList.add("done");
      tagCart(handle);   // attribution: session id + this rec handle ride to the Order (observe-only)
      document.dispatchEvent(new CustomEvent("gregwein:added"));   // let the theme refresh its cart
    } catch (e) {
      btn.textContent = orig;   // demo / not on the storefront — cart works on bighammerwines.com
    }
  }

  // Write GregWein attribution onto the cart as order-level note attributes (survive to the
  // Order as customAttributes — the nightly Mac-side join key). Best-effort like the add:
  // a non-storefront demo just no-ops. Appends the rec handle (deduped, cap 8) so a session
  // that added two recs credits both. No PII, no cost — just {session, recs, ts}.
  async function tagCart(handle) {
    try {
      var cart = await getCart();
      var prev = (cart && cart.attributes && cart.attributes._gw_recs) || "";
      var recs = prev ? prev.split(",") : [];
      if (handle && recs.indexOf(handle) === -1) recs.push(handle);
      recs = recs.slice(-8);
      await fetch("/cart/update.js", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: {
          _gw_sid: sid, _gw_recs: recs.join(","), _gw_ts: new Date().toISOString() } }),
      });
    } catch (e) { /* best-effort */ }
  }

  async function getCart() {
    try { var r = await fetch("/cart.js", { credentials: "same-origin" }); return await r.json(); }
    catch (e) { return null; }
  }

  function sendText(text) {
    if (!text || busy) return;
    if (!built) build();
    if (!inlineMode && panel.style.display === "none") open();
    input.value = text;
    send();
  }

  function anchorTop(el) {   // scroll the log so el's top sits at the log's top — read the answer from the start
    try { log.scrollTop += el.getBoundingClientRect().top - log.getBoundingClientRect().top - 8; } catch (e) {}
  }
  async function send() {
    var text = input.value.trim();
    if (!text || busy) return;
    busy = true; input.value = "";
    var userMsg = add("user", esc(text));
    // "working" state: rotating in-voice line + skeleton bars, replaced the instant real text streams.
    var THINK = ["Let me taste through the cellar…", "Pulling a few real options…",
                 "Checking what we've got open right now…", "Lining up something worth your money…"];
    var typing = add("a", '<div class="gw-think"><div class="gw-status">' + THINK[0] +
                          '</div><div class="gw-sk w1"></div><div class="gw-sk w2"></div><div class="gw-sk w3"></div></div>');
    var _ti = 0, thinkTimer = setInterval(function () {
      var s = typing.querySelector(".gw-status");
      if (!s) { clearInterval(thinkTimer); thinkTimer = null; return; }   // real text arrived
      _ti = (_ti + 1) % THINK.length; s.textContent = THINK[_ti];
    }, 2600);
    function stopThink() { if (thinkTimer) { clearInterval(thinkTimer); thinkTimer = null; } }
    anchorTop(userMsg);   // keep the question at the top so the answer reads from its start, not its end
    var cart = await getCart();
    var payload = { message: text, session_id: sid, history: history.slice(-12), cart: cart, page: PAGE };
    var acc = "", products = null, finalReply = null;
    try {
      var res = await fetch(ENDPOINT, {
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload),
      });
      if (res.body && res.body.getReader) {
        // SSE stream: append 'delta' chunks live; 'done' carries products; 'replace' swaps text.
        var reader = res.body.getReader(), dec = new TextDecoder(), buf = "";
        while (true) {
          var chunk = await reader.read();
          if (chunk.done) break;
          buf += dec.decode(chunk.value, { stream: true });
          var parts = buf.split("\n\n"); buf = parts.pop();
          for (var i = 0; i < parts.length; i++) {
            var ln = parts[i].replace(/^data: ?/, "").trim();
            if (!ln) continue;
            var ev; try { ev = JSON.parse(ln); } catch (e2) { continue; }
            if (ev.type === "delta") { stopThink(); acc += ev.text || ""; typing.innerHTML = md(acc); }
            else if (ev.type === "done") { products = ev.products; if (ev.reply) finalReply = ev.reply; }
            else if (ev.type === "replace") { finalReply = ev.reply || ""; products = ev.products || []; }
          }
        }
      } else {                                   // host doesn't stream — JSON fallback
        var data = await res.json();
        finalReply = data.reply; products = data.products;
      }
      stopThink();
      var reply = (finalReply != null && (finalReply !== acc || !acc)) ? finalReply : acc;
      typing.innerHTML = md(reply) + cards(products);
      history.push({ role: "user", content: text });
      history.push({ role: "assistant", content: reply });
      save();
    } catch (e) {
      stopThink();
      typing.innerHTML = acc ? (md(acc) + cards(products)) : "I'm having trouble right now — give it another go in a moment.";
    }
    anchorTop(userMsg);   // land on the start of the answer, not scrolled to its end
    busy = false; input.focus();
  }

  function open() {
    if (!built) build();
    warm(); try { clearInterval(warmTimer); warmTimer = setInterval(warm, 240000); } catch (e) {}
    if (inlineMode) { input.focus(); return; }
    if (backdrop) backdrop.style.display = "block";
    panel.style.display = "flex";
    var b = root.getElementById("gw-btn"); if (b) b.style.display = "none";
    try { sessionStorage.setItem("gregwein_open", "1"); } catch (e) {}
    if (!greeted && !history.length) greet();
    input.focus();
  }
  function close() {
    endVoice();
    try { clearInterval(warmTimer); } catch (e) {}
    if (backdrop) backdrop.style.display = "none";
    panel.style.display = "none";
    var b = root.getElementById("gw-btn");
    // clear the inline override so the class's inline-flex applies — display:"block" here
    // collapsed the avatar span to a sliver and left a bare "Ask Greg" oblong (2026-07-02)
    if (b) b.style.display = "";
    try { sessionStorage.removeItem("gregwein_open"); } catch (e) {}
  }

  function build() {
    if (built) return;
    var target = document.getElementById("gregwein-chat") || document.querySelector("[data-gregwein-chat]");
    inlineMode = !!target;
    var hostEl = target || el("div");
    if (!inlineMode) document.body.appendChild(hostEl);
    root = hostEl.attachShadow({ mode: "open" });
    // The host's content lives entirely in the shadow root, so the host is light-DOM-empty.
    // Some themes hide empty elements (`:empty{display:none}`), and a display:none ancestor
    // hides even the position:fixed panel. Force the host visible so the chat always renders.
    hostEl.style.setProperty("display", "block", "important");
    root.appendChild(el("style", null, CSS));

    if (!inlineMode) {
      backdrop = el("div", { class: "backdrop" });
      backdrop.onclick = close;
      root.appendChild(backdrop);
    }

    panel = el("div", { class: "panel" + (inlineMode ? " inline" : " modal") });
    if (!inlineMode) panel.style.display = "none";
    var hd = el("div", { class: "hd" },
      "<span>Ask Greg<br><span class='sub'>Big Hammer Wines · real picks from our cellar</span></span>");
    var x = el("button", null, "×"); x.onclick = close; hd.appendChild(x);
    log = el("div", { class: "log" });
    log.addEventListener("click", function (e) {
      var b = e.target.closest && e.target.closest(".add");
      if (b && b.dataset.v) addToCart(b.dataset.v, b.dataset.h, b);
    });
    var ft = el("div", { class: "ft" });
    input = el("input", { type: "text", placeholder: "What are you in the mood for?" });
    input.addEventListener("keydown", function (e) { if (e.key === "Enter") send(); });
    var sb = el("button", null, "Send"); sb.onclick = send;
    ft.appendChild(input);
    if (window.GREGWEIN_VOICE) { micBtn = el("button", { class: "gw-mic", title: "Talk to Greg", "aria-label": "Talk to Greg by voice" }, MIC_SVG); micBtn.onclick = toggleVoice; ft.appendChild(micBtn); }
    ft.appendChild(sb);
    panel.appendChild(hd); panel.appendChild(log); panel.appendChild(ft);

    // floating bubble only when NOT inline and not suppressed (a page CTA / existing bubble)
    if (!inlineMode && !window.GREGWEIN_NO_BUTTON) {
      var btn;
      if (LAUNCHER === "avatar") {
        var ava = AVATAR
          ? '<span class="gw-ava" style="background-image:url(\'' + esc(AVATAR) + '\')"></span>'
          : '<span class="gw-ava gw-ini">GM</span>';
        btn = el("button", { class: "btn avatar " + SIDE, id: "gw-btn", "aria-label": "Ask Greg" },
                 ava + '<span class="gw-lab">' + esc(launcherLabel()) + "</span>");
      } else {
        btn = el("button", { class: "btn " + SIDE, id: "gw-btn" }, "🍷 " + CTA);
      }
      btn.style.bottom = OFFSET_B + "px";   // stack above any existing corner widget (e.g. rewards)
      btn.onclick = open;
      root.appendChild(btn);
      // Collection pages: the launcher shares the bottom-left corner with the desktop
      // filter sidebar — when the sidebar's tail (Price Slider / Pack Size) scrolls into
      // the launcher's zone, glide the button underneath it so every filter stays
      // clickable; it returns to OFFSET_B once the filters scroll past (Greg 2026-07-03).
      var facets = document.getElementById("FacetFiltersContainer");
      if (facets) {
        btn.style.transition = "bottom .25s ease";
        var dodgeTick = false;
        var dodge = function () {
          dodgeTick = false;
          var want = OFFSET_B;
          if (facets.offsetParent) {              // sidebar visible (desktop only)
            var r = facets.getBoundingClientRect(), vh = window.innerHeight,
                bh = btn.offsetHeight || 52;
            if (r.height && r.bottom > vh - OFFSET_B - bh - 12) {
              want = Math.max(14, Math.min(OFFSET_B, vh - r.bottom - bh - 12));
            }
          }
          btn.style.bottom = want + "px";
        };
        var onSc = function () { if (!dodgeTick) { dodgeTick = true; requestAnimationFrame(dodge); } };
        window.addEventListener("scroll", onSc, { passive: true });
        window.addEventListener("resize", onSc, { passive: true });
        dodge();
      }
    }
    root.appendChild(panel);
    if (!inlineMode) document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
    built = true;

    // restore prior conversation text (cards are ephemeral) so navigation doesn't lose it
    if (history.length) {
      greeted = true;
      history.forEach(function (m) {
        add(m.role === "user" ? "user" : "a", m.role === "user" ? esc(m.content) : md(m.content));
      });
    }
    warm();   // warm the backend on widget init (page load), before the user even clicks
    if (inlineMode) { greet(); input.focus(); try { warmTimer = setInterval(warm, 240000); } catch (e) {} }
  }

  // Page chips / external buttons can fire a question:  window.GregWein.ask("What pairs with steak?")
  window.GregWein = { ask: sendText, open: open };

  function init() {
    build();
    if (!inlineMode) {
      var wasOpen = false;
      try { wasOpen = sessionStorage.getItem("gregwein_open") === "1"; } catch (e) {}
      if (wasOpen) open();
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
